import { Helmet } from "react-helmet";
import BreadcrumbComponent from "../../components/BreadcrumbComponent/BreadcrumbComponent";
import { BREADCRUMB_COOKIE } from "../../utils/BreadcrumbEnums";
import "./Cookie.scss";
import { APP_NAME } from "../../utils/Constans";

/**
 * @function Cookie page rendering the Cookie
 * @returns {JSX.Element}
*/
const Cookie = () => {
    return (
        <div className="Cookie">
            <BreadcrumbComponent items={ BREADCRUMB_COOKIE }></BreadcrumbComponent>
            <Helmet>
                <title>{APP_NAME} | Cookie</title>
            </Helmet>
            <div className="Cookie__title mb-3" tabIndex="0" role="contentinfo">
                <h1>Cookie</h1>
            </div>
            <div className="Cookie__paragrafo" tabIndex="0" role="contentinfo">
                <span className="fw-600">Questo sito non fa uso di cookie di profilazione o di altri strumenti di tracciamento.</span>
            </div>
        </div>

    );
};


export default Cookie;